import {Component, ElementRef, OnInit, ChangeDetectionStrategy, inject} from '@angular/core';
import { AuthTokenStore } from '../../services/auth-token/auth-token.store';
import {
  ToastController,
  Platform,
  IonBackButton,
  IonButton,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonNav,
  IonToolbar,
} from '@ionic/angular';
import {ActivatedRoute, NavigationExtras, Router, } from '@angular/router';
import {NetworkService, ApiService, ExclusionService, Events, PushserviceService } from '../../services/services';
import moment from 'moment';
import {environment as ENV} from '../../../environments/environment';
import {InfoWindowDialogComponent} from "../../components/info-window-dialog/info-window-dialog.component";
import {FormsModule} from "@angular/forms";
import {NgClass} from "@angular/common";
import {AmplitudeService} from "../../services/amplitude/amplitude.service";
import {FirebaseStatsService} from "../../services/firebasestats/firebase-stats.service";
import {AppsflyerService} from "../../services/services";
import {Capacitor} from '@capacitor/core';
import {
  NativeCredentialManager,
  PasswordCredential,
  takePasswordCredential
} from '../../plugins/native-credential-manager';
import {DeepLinkService} from "../../services/deep-link/deep-link.service";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
  imports: [
    IonHeader,
    IonToolbar,
    IonBackButton,
    IonContent,
    InfoWindowDialogComponent,
    IonList,
    FormsModule,
    NgClass,
    IonItem,
    IonLabel,
    IonInput,
    IonFooter,
    IonButton,
  ]
})


export class LoginPage {
  private readonly authTokenStore = inject(AuthTokenStore);

  account: { email: string; userId: any; photoVerificationRequired: boolean; token: any; ucn: any; password: string } = {
    email: '',
    userId: null,
    photoVerificationRequired: false,
    token: null,
    ucn: null,
    password: '',
  };

  showPassIcon = '/assets/sign_up_sign_in/password-icon.png';

  passwordType = 'password';
  passwordIcon = 'prefix-pass-eye-off';
  showInfoWindow = false;
  infoWindowTitle = 'User blocked';
  infoWindowDescription = '';
  infoWindowCloseText = 'OK';
  private loadedCredential: PasswordCredential | null = null;


  constructor(
    private route: ActivatedRoute,
    private elRef: ElementRef,
    private router: Router,
    public networkServ: NetworkService,
    public api: ApiService,
    public excl: ExclusionService,
    public events: Events,
    public toastController: ToastController,
    public pushServ: PushserviceService,
    private ampl:AmplitudeService,
    public firebaseStats: FirebaseStatsService,
    public plt: Platform,
    public appsFlyerServ: AppsflyerService,
    private deepLinkService: DeepLinkService,
  ) {
    this.route.queryParams.subscribe(params => {
      if(params['email']){
        // console.log('params', params);
        // console.log('params[\'email\']', params['email']);
        // const paramData = JSON.parse(params['account']);
        this.account.email = params['email'];
        void this.usePendingPasswordCredential();
        // console.log('params', paramData.account.email);
        console.log('this.account', this.account);
      }
    });
  }


  hideShowPassword(e) {
    e.preventDefault();
    console.log("hideShowPassword");
    const passInput = this.elRef.nativeElement.querySelector('.passwordInput');
    const el2 = passInput.querySelectorAll('input');
    this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
    this.passwordIcon = this.passwordIcon === 'prefix-pass-eye-off' ? 'prefix-pass-eye-on' : 'prefix-pass-eye-off';
    setTimeout(() => {
      el2[0].focus()
      el2[0].setSelectionRange(this.account.password.length,this.account.password.length);
    },500);

  }

  setCaretPosition(ev) {
    const passInput = this.elRef.nativeElement.querySelector('.passwordInput');
    const el2 = passInput.querySelectorAll('input');
    el2[0].setSelectionRange(this.account.password.length,this.account.password.length);
  }

  goTo(page: string, params?) {
    this.router.navigate([page], { queryParams: {account:  JSON.stringify(params)} });
    // this.router.navigate([page], navigationExtras);
    // this.navCtrl.push(page, params);
  }

  async doLogin(form) {

    //internet connection check
    const conn: any = await this.networkServ.checkInternet();
    if(!conn.result){
      return false;
    }


    // register the user
    this.api.userSingIn(this.account).subscribe(async (item) => {
      console.log('item', item);
      const user = item.data;
      this.account = {...this.account, ...{partnerId: user.partner_id}};

      const userSessionToken = user.token;


      // save the users token


      const notExcluded: any = await this.excl.checkExclusion(user.token, 'login');
      if (notExcluded.result) {
        void this.authTokenStore.setToken(userSessionToken);
        localStorage.setItem('userCreatedAt', user.created_at);
        localStorage.setItem('partnerId', user.partner_id);
        localStorage.setItem('user_id', user.id);


        // this.appsFlyerServ.sendLogEvent('af_login');
        this.appsFlyerServ.setUserId(user.id);
        this.appsFlyerServ.sendAppsFlyerUIDToServer(userSessionToken);

        //AMPLITUDE
        this.ampl.setUserId(user.id)
        setTimeout(()=>{
          this.ampl.trackEvent('sign_in', {
            user_id: user.id
          })
        },1000)

        // Setup OneSignal Notifications
        this.pushServ.setupPush(user);

        await this.savePasswordCredential();
        this.router.navigate(['/tabs/home']);
        const resumedDeepLink = await this.deepLinkService.resumePending();
        if (!resumedDeepLink) {
          this.router.navigate(['/tabs/games']);
        }
      } else if (notExcluded.data.apiCode === 'EXCLUDED') {
        this.firebaseStats.sendEvent('self_exclusion', {user_id: user.id, exclusion_type: 'SELF EXCLUDED'})
        this.infoWindowDescription = 'Your account has been restricted for ' + notExcluded.data.length + ' from ' + moment.utc(notExcluded.data.since.date).local().format("DD MMMM YYYY H:mm:ss") + '. Please contact ' + ENV.supportEmail + ' for more information.';
        if (notExcluded.data.reason === 'self') {
          this.infoWindowDescription = this.infoWindowDescription + '<br /> To self-exclude from participating online gambling companies licensed in Great Britain go to <a href="https://www.gamstop.co.uk">https://www.gamstop.co.uk.</a>';
        }
        this.events.publish('showInfoDialog');
      } else if(notExcluded.data.apiCode === 'GAMSTOP') {
        this.firebaseStats.sendEvent('self_exclusion', {user_id: user.id, exclusion_type: 'GAMSTOP EXCLUDED'})
        this.infoWindowDescription = 'Your account has been restricted. Please contact <a href="mailto:'+ENV.supportEmail+'">' + ENV.supportEmail + '</a> for more information.';
        this.events.publish('showInfoDialog');


      } else {

        this.presentToast('Sorry, we can’t match that Email and Password. Please check them or use the Forgotten Password function.', 10000);
      }

    }, (err) => {
      console.log('err', err);
      // console.log('login err', err.status);
      const apiCode = err?.error?.apiCode;
      const backendMessage = err?.error?.data?.message;
      let message = backendMessage;

      if(err.status === 401) {
        console.log('login problems');
        message = apiCode === 'NOT_AUTORIZED' && backendMessage
          ? backendMessage
          : 'Sorry, we can’t match that Email and Password. Please check them or use the Forgotten Password function.';
      } else if(err.status === 400){
        message = 'Sorry, we can’t match that Email and Password. Please check them or use the Forgotten Password function.';
      }else if(err.status === 500) {
        console.log('server problems');
        /* tslint:disable:no-unused-variable */
        message = 'There was a server issue when logging in. Please try again later.';
      }
      // Unable to sign up
      // let $errortext = JSON.stringify(err);
      this.presentToast(message, 10000);
    });
    return true;
  }

  async presentToast(msg, dur, position = 'top') {
    const toast = await this.toastController.create({
      message: msg,
      duration: dur,
      position: 'top'
    });
    toast.present();
  }

  ionViewWillEnter(){
    this.plt.ready().then((readySource) => {
      // FIREBASE ANALYTICS SCREEN
      this.account.password = '';
      this.firebaseStats.sendEvent('screen_view', {screen_name: "LoginScreen", screen_class: "Login Password"});
      void this.usePendingPasswordCredential();
    })
  }

  ionViewWillLeave(){
    this.account.password = '';
  }

  private async usePendingPasswordCredential(): Promise<void> {
    if (Capacitor.getPlatform() !== 'android') {
      return;
    }

    const credential = takePasswordCredential(this.account.email);
    if (credential) {
      this.loadedCredential = credential;
      this.account.password = credential.password;
      await this.doLogin(null);
    }
  }

  private async savePasswordCredential(): Promise<void> {
    if (Capacitor.getPlatform() !== 'android') {
      return;
    }

    if (
      this.loadedCredential &&
      this.loadedCredential.username.toLowerCase() === this.account.email.toLowerCase() &&
      this.loadedCredential.password === this.account.password
    ) {
      return;
    }

    try {
      await NativeCredentialManager.savePassword({
        username: this.account.email,
        password: this.account.password
      });
    } catch {
      // Saving credentials is optional and must not block a successful login.
    }
  }


}
